import { render, staticRenderFns } from "./NoticeConfigDialog.vue?vue&type=template&id=6828d126&scoped=true"
import script from "./NoticeConfigDialog.vue?vue&type=script&lang=js"
export * from "./NoticeConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./NoticeConfigDialog.vue?vue&type=style&index=0&id=6828d126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828d126",
  null
  
)

export default component.exports